import React, { FunctionComponent } from 'react';
import { ApolloError } from 'apollo-boost';
import { pathOr } from 'ramda';

import Query from 'components/Query';
import { useDatePicker } from 'components/DatePicker/DatePicker.context';
import { ChartPlaceholder } from 'components/Placeholder';
import TransactionsChart from 'components/TransactionsChart';
import { Transactions } from 'components/TransactionsChart/TransactionsChart.helpers';
import { Params } from 'helpers/filters';

import { GET_MERCHANT_CN_TRANSACTIONS } from './MerchantCNTransactions.queries';

type Props = {
  merchantId: string;
};

type QueryResponse = {
  cnTransactions: Transactions;
  loading?: boolean;
  error?: ApolloError;
};

const renderTransaction = (parameters: Params) => (response: QueryResponse) => {
  const cnTransactions = pathOr(
    [],
    ['data', 'cnTransactionsByMarketplace', 'DOSH'],
    response,
  ) as Transactions;

  if (response.loading) {
    return <ChartPlaceholder />;
  }

  return (
    <TransactionsChart transactions={cnTransactions} parameters={parameters} />
  );
};

const MerchantCNTransactions: FunctionComponent<Props> = ({ merchantId }) => {
  const { startDate, endDate } = useDatePicker();
  const params = { startDate, endDate, merchantId };

  return (
    <Query
      enableProgressInfo
      query={GET_MERCHANT_CN_TRANSACTIONS}
      variables={{
        params,
      }}
      render={renderTransaction(params)}
    />
  );
};

export default MerchantCNTransactions;
